import clsx from "clsx";
import { memo, useMemo } from "react";

import classes from "./styles.module.scss";

import { FastButton } from "@components/fastFields/fastButton";
import type { IFormButtonsProps } from "@components/organisms/formButtons/types";
import { IButtonModeEnum } from "@components/molecules/button";
import { usePageMode } from "@/stores/uiStore";

export const FormButtons = memo(function FormButtons({
  cancelButtonProps,
  submitButtonProps,
  customButtons,
  noCancel,
  noSubmit,
  isLoading,
  noBack,
}: IFormButtonsProps) {
  const mode = usePageMode();

  const customButtonsList = useMemo(
    () =>
      customButtons?.map((button) => (
        <FastButton
          className={clsx(classes.button)}
          key={button.key || button?.type}
          {...button}
        />
      )),
    [customButtons],
  );

  return (
    <div className={clsx(classes.container)}>
      {customButtons ? (
        <>{customButtonsList}</>
      ) : (
        <>
          {!noCancel && (
            <FastButton
              className={clsx(classes.button)}
              type={noBack || mode === "create" ? "cancelAndBack" : "back"}
              {...cancelButtonProps}
            />
          )}
          {!noSubmit && (
            <FastButton
              className={clsx(classes.button)}
              isLoading={isLoading}
              type={"saveAndSend"}
              mode={IButtonModeEnum.Submit}
              {...submitButtonProps}
            />
          )}
        </>
      )}
    </div>
  );
});
FormButtons.displayName = "FormButtons";
